import { Button, Flex, Modal, Input } from 'antd';
import React, { useContext } from 'react';

import { CloseIconsForModalWithDataTestId } from '@app/components/CloseIconsForModalWithDataTestId';
import { FRONT_WARNING } from '@app/constants';
import type { NSendMessageModal } from '@app/features/SendoutCreationModal/components/SendMessageModal/SendMessageModal.types';
import { NotificationContext } from '@app/providers';
import { generateSpanWithDataTestId } from '@app/shared/utils';

const { TextArea } = Input;
export const MessagesPreviewWindow: React.FC<
  NSendMessageModal.MessagesPreviewModalProps
> = ({ data, setIsMessagesPreviewModalOpen, isMessagesPreviewModalOpen }) => {
  const { showNotification } = useContext(NotificationContext);

  const handleCancel = () => {
    setIsMessagesPreviewModalOpen(false);
  };

  return (
    <Modal
      open={isMessagesPreviewModalOpen}
      title={generateSpanWithDataTestId(
        'Предварительный просмотр сообщения',
        'preview-message-title'
      )}
      onCancel={handleCancel}
      footer={
        <Button onClick={handleCancel} data-testid="close">
          Закрыть
        </Button>
      }
      className="messages-preview-modal"
      data-testid="preview-message-popup"
      closeIcon={<CloseIconsForModalWithDataTestId />}
    >
      <Flex vertical={true} gap={10}>
        {data.map((message, index) => (
          <TextArea
            key={index}
            autoSize={{ minRows: 4, maxRows: 4 }}
            value={message}
            data-testid="message-text"
            onChange={() =>
              showNotification(
                'Данное поле предназначено только для просмотра информации',
                FRONT_WARNING
              )
            }
          />
        ))}
      </Flex>
    </Modal>
  );
};
